import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as tags from '../../../constants';

import { TimingWrapper, TimingLabel } from './styles';

class TennisTiming extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  formatDate = (datePassed) => {
    const dateJs = new Date(datePassed);
    const hours = (`0${dateJs.getHours().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    const minutes = (`0${dateJs.getMinutes().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
    return `${hours}:${minutes}`;
  };

  timingCountDown = (date) => {
    const start = new Date(date).getTime();
    const now = Date.now();
    const timeDiff = start - now;
    const seconds = Math.floor(timeDiff / 1000);
    const minute = Math.floor(seconds / 60);
    if ((timeDiff <= 3600000) && (minute > 0)) {
      return `-${minute}'`;
    } else {
      return this.formatDate(date);
    }
  };

  endedLabel = (endedStatusDetail) => {
    switch (endedStatusDetail) {
      case tags.WALKOVER:
        return 'Walkover';
      case tags.RETIRED:
        return 'Ritiro';
      case tags.DEFAULTED:
        return 'Default';
      case tags.SUSPENDED_STATUS:
        return 'Sosp.';
      case tags.BYE:
        return 'Bye';
      default:
        return 'Fine';
    }
  };

  timingLabel = (matchRow) => {
    switch (matchRow.get('status')) {
      case tags.NOTSTARTED:
        return this.timingCountDown(matchRow.get('date'));
      case tags.INPLAY:
        return `${matchRow.get('currentSet')}° set`;
      case tags.FINISHED:
        return this.endedLabel(matchRow.get('statusDetail'));
      case tags.SUSPENDED_STATUS:
        return this.endedLabel(matchRow.get('statusDetail'));
      default:
        return '';
    }
  };

  isEnded = (timing) => {
    if (timing.get('status') === tags.FINISHED) {
      return true;
    }
    return false;
  };

  render() {
    const {
      matchRow,
      isLive,
      isMobile,
    } = this.props;
    return (
      <TimingWrapper
        isMobile={isMobile}
      >
        <TimingLabel
          color={isLive ? 'liveColor' : 'black'}
          font={(isLive || this.isEnded(matchRow)) ? 'narrowMedium' : 'narrowRegular'}
        >
          {this.timingLabel(matchRow, isMobile)}
        </TimingLabel>
      </TimingWrapper>
    );
  }
}

TennisTiming.propTypes = {
  matchRow: PropTypes.any,
  //dictionary: PropTypes.any,
  isLive: PropTypes.any,
  isMobile: PropTypes.bool,
};

export default TennisTiming;

/*
walkover: passaggio al turno successivo di un giocatore, senza
disputare l'incontro per infortunio, ritiro o squalifica
del suo avversario

defaulted: giocatore espulso dal campo dall’arbitro dopo quattro
violazioni del codice di comportamento

bye: Giocatore inserito in tabellone direttamente in un
turno successivo al primo, accoppiato ad un giocatore
proveniente dal turno precedente o ad un altro
esentato
 */



// WEBPACK FOOTER //
// ./src/components/TimeResults/TennisTimig/index.js